import type { QueryClient } from '@tanstack/react-query';
import type { DashboardType } from '@/types/Analytics.ts';

export const dashboardWidgetsDataQueryKey = (dashboard: DashboardType) => ['dashboard-widgets-data', dashboard] as const;

export const dashboardWidgetsListQueryKey = (dashboard: DashboardType) => ['dashboard-widgets', dashboard] as const;

export const invalidateDashboardWidgetsData = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: ['dashboard-widgets-data'] });
};
